/** @format */

import { FunctionComponent as FC, useMemo, useState } from 'react';
import { LanguageSwitcherContext } from './LanguageSwitcherContext';

export const LanguageSwitcherProvider: FC<Props> = ({ children }) => {
  const [slugs, setSlugs] = useState<{
    [key: string]: string;
  }>({});

  const value = useMemo(() => {
    return { slugs, setSlugs };
  }, [slugs]);

  return <LanguageSwitcherContext.Provider value={value}>{children}</LanguageSwitcherContext.Provider>;
};

type Props = {
  children: React.ReactNode;
};
